import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaLock, FaUser, FaPowerOff } from "react-icons/fa";

export default function ViewPersonal({ onLogout }) {
  const [view, setView] = useState("main");
  const [user, setUser] = useState({});
  const [cryptoList, setCryptoList] = useState([]);
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    crypto_bank: "",
    wallet_code: "",
  });
  const [passwords, setPasswords] = useState({
    current: "",
    newPass: "",
    confirm: "",
  });
  const [msg, setMsg] = useState("");

  // ✅ Load user and crypto list
  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem("user"));
    if (savedUser) {
      setUser(savedUser);
      setFormData({
        firstname: savedUser.firstname || "",
        lastname: savedUser.lastname || "",
        email: savedUser.email || "",
        phone: savedUser.phone || "",
        crypto_bank: savedUser.crypto_bank || "",
        wallet_code: savedUser.wallet_code || "",
      });
    }

    fetch("https://api.backofficemain.com/get_crypto_list.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setCryptoList(data.crypto_bank);
      })
      .catch((err) => console.error("Error loading crypto list:", err));
  }, []);

  // ✅ Handle profile update
  const handleProfileUpdate = async () => {
    try {
      const res = await fetch("https://api.backofficemain.com/update_profile.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: user.username, ...formData }),
      });
      const data = await res.json();
      if (data.success) {
        localStorage.setItem("user", JSON.stringify({ ...user, ...formData }));
        setMsg("Profile updated successfully!");
      } else {
        setMsg(data.message || "Failed to update profile.");
      }
    } catch (e) {
      console.error(e);
      setMsg("Error updating profile.");
    }
  };

  // ✅ Handle password update
  const handlePasswordUpdate = async () => {
    if (passwords.newPass !== passwords.confirm) {
      setMsg("New passwords do not match.");
      return;
    }
    try {
      const res = await fetch("https://api.backofficemain.com/update_password.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user.username,
          current: passwords.current,
          newPass: passwords.newPass,
        }),
      });
      const data = await res.json();
      setMsg(data.message || (data.success ? "Password updated!" : "Failed to update password."));
    } catch (e) {
      console.error(e);
      setMsg("Error updating password.");
    }
  };

  return (
    <div className="container py-3">
      <div className="text-center fw-bold fs-5 mb-3 text-danger">Settings</div>

      {/* ✅ Main Menu */}
      {view === "main" && (
        <div className="card shadow-sm p-3">
          <div className="d-flex align-items-center border-bottom py-2" onClick={() => setView("security")}>
            <FaLock className="text-danger me-3 fs-4" />
            <div>
              <div className="fw-bold text-danger">Security Setting</div>
              <div className="text-muted small">PIN Password, Login Password</div>
            </div>
          </div>

          <div className="d-flex align-items-center border-bottom py-2" onClick={() => setView("account")}>
            <FaUser className="text-danger me-3 fs-4" />
            <div>
              <div className="fw-bold text-danger">My Account</div>
              <div className="text-muted small">Update Profile Information</div>
            </div>
          </div>

          <div className="d-flex align-items-center py-2" onClick={onLogout}>
            <FaPowerOff className="text-danger me-3 fs-4" />
            <div>
              <div className="fw-bold text-danger">Logout Account</div>
              <div className="text-muted small">Logout Account And Return to Home</div>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Account Info View */}
      {view === "account" && (
        <div className="card shadow-sm p-4">
          <div className="d-flex align-items-center mb-3">
            <FaUser className="text-danger me-2 fs-4" />
            <h5 className="fw-bold text-danger mb-0">Edit Profile Information</h5>
          </div>

          <div className="mb-3">
            <label>First Name</label>
            <input
              type="text"
              className="form-control"
              value={formData.firstname}
              onChange={(e) => setFormData({ ...formData, firstname: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label>Last Name</label>
            <input
              type="text"
              className="form-control"
              value={formData.lastname}
              onChange={(e) => setFormData({ ...formData, lastname: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label>Phone</label>
            <input
              type="text"
              className="form-control"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            />
          </div>

          {/* ✅ Dropdown for Crypto */}
          <div className="mb-3">
            <label>Cryptocurrency</label>
            <select
              className="form-select"
              value={formData.crypto_bank}
              onChange={(e) => setFormData({ ...formData, crypto_bank: e.target.value })}
            >
              <option value="">Select Crypto</option>
              {cryptoList.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.crypto_name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label>Wallet Address</label>
            <input
              type="text"
              className="form-control"
              value={formData.wallet_code}
              onChange={(e) => setFormData({ ...formData, wallet_code: e.target.value })}
            />
          </div>

          {msg && <div className="alert alert-info">{msg}</div>}

          <button className="btn btn-danger w-100 rounded-pill" onClick={handleProfileUpdate}>
            ✓ Update Profile Information
          </button>

          <button className="btn btn-link text-danger mt-3" onClick={() => setView("main")}>
            ← Back
          </button>
        </div>
      )}

      {/* ✅ Security Setting */}
      {view === "security" && (
        <div className="card shadow-sm p-4">
          <div className="d-flex align-items-center mb-3">
            <FaLock className="text-danger me-2 fs-4" />
            <h5 className="fw-bold text-danger mb-0">Reset Password</h5>
          </div>

          <div className="mb-3">
            <label>Current Password</label>
            <input
              type="password"
              className="form-control"
              value={passwords.current}
              onChange={(e) => setPasswords({ ...passwords, current: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label>New Password</label>
            <input
              type="password"
              className="form-control"
              value={passwords.newPass}
              onChange={(e) => setPasswords({ ...passwords, newPass: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label>Confirm Password</label>
            <input
              type="password"
              className="form-control"
              value={passwords.confirm}
              onChange={(e) => setPasswords({ ...passwords, confirm: e.target.value })}
            />
          </div>

          {msg && <div className="alert alert-info">{msg}</div>}

          <button className="btn btn-danger w-100 rounded-pill" onClick={handlePasswordUpdate}>
            ✓ Update Password
          </button>

          <button className="btn btn-link text-danger mt-3" onClick={() => setView("main")}>
            ← Back
          </button>
        </div>
      )}
    </div>
  );
}
